module.exports = __webpack_public_path__ + "static/media/PDF_54.4ae6a46c.pdf";